export type SkeletonProps = { className?: string }

export function Skeleton({ className = '' }: SkeletonProps) {
  // 动效降级统一 motion-safe 写法（11 §9.3）：reduced-motion 下静态色块，加载占位不依赖动画传达语义
  return <div aria-hidden="true" className={`motion-safe:animate-pulse rounded-[var(--radius-sm)] bg-[var(--color-soft)] ${className}`.trim()} />
}

export type SkeletonLinesProps = {
  lines?: number
  className?: string
}

const lineWidths = ['w-full', 'w-[85%]', 'w-[60%]'] as const

export function SkeletonLines({ lines = 3, className = '' }: SkeletonLinesProps) {
  return (
    <div aria-hidden="true" className={`space-y-2.5 ${className}`.trim()}>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} className={`h-3.5 ${lineWidths[index % lineWidths.length]}`} />
      ))}
    </div>
  )
}
